import { useQuery } from '@tanstack/react-query'
import { ClientLocationSpeciesService } from '../services'
import { APILocationSpeciesClientDtoResponse } from '../types'
import { defaultQueryOptions } from './common'

export const useClientLocationSpecies = (
  locationName: string,
  includeBreeds = false,
  options?: { enabled?: boolean }
) => {
  const { enabled = true } = options || {}
  return useQuery<APILocationSpeciesClientDtoResponse>({
    queryKey: ['clientLocationSpecies', locationName, includeBreeds],
    queryFn: () => ClientLocationSpeciesService.getSpecies(locationName, includeBreeds),
    ...defaultQueryOptions,
    enabled,
  })
}
